import React from 'react';
import './ServicesList.css';

const ServicesList = () => {
  const services = [
    { text: 'Prêt professionnel', colorClass: 'color-1' },
    { text: 'Assurance de prêt', colorClass: 'color-2' },
    { text: '• Prêt immobilier', colorClass: 'highlight' },
    { text: 'Regroupement de crédits', colorClass: 'color-2' },
    { text: 'Prêt locatif', colorClass: 'color-1' }
  ];

  return (
    <div className="services-list">
      {services.map((service, index) => (
        <p key={index} className={`service-item ${service.colorClass}`}>
          {service.text}
        </p>
      ))}
    </div>
  );
};

export default ServicesList;

